import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const PayPalIcon = (props: IconProps) => (
  <StyledIcon
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.94058 2.42625C7.4749 2.45223 9.03896 2.41205 10.5751 2.43058C11.5382 2.45087 12.5115 2.35784 13.461 2.54853C14.957 2.84899 16.2572 3.8246 16.8166 5.26538C17.0251 5.80233 17.0707 6.28927 17.1266 6.85564L17.1422 6.8667C19.4844 8.12294 20.0154 10.7142 18.7814 12.981C18.0893 14.2492 16.9248 15.1927 15.5409 15.6065C14.4244 15.9322 12.9185 15.8412 11.7328 15.8385C11.6673 16.4646 11.5545 17.2189 11.4291 17.8367C11.1853 19.0392 11.088 20.3891 10.8131 21.5747L6.89591 21.5704C7.08551 20.3088 7.31798 19.0549 7.50527 17.798C7.36946 17.6832 4.01826 17.745 3.57227 17.7456C3.81844 15.8083 4.18728 13.6853 4.49353 11.7445L5.94058 2.42625Z"
      fill="#002992"
    />
    <path
      d="M17.1427 6.86621C19.485 8.12246 20.016 10.7137 18.782 12.9806C18.0899 14.2487 16.9254 15.1923 15.5415 15.606C14.425 15.9317 12.919 15.8408 11.7333 15.838C11.6678 16.4641 11.555 17.2184 11.4296 17.8363C11.1858 19.0388 11.0886 20.3886 10.8136 21.5742L6.89648 21.57C7.08608 20.3083 7.31856 19.0544 7.50584 17.7975C7.6394 17.1311 7.75366 16.2505 7.85943 15.5644L8.40814 12.0206L10.5197 12.0221C12.0222 12.0228 13.1301 12.0323 14.4819 11.207C15.6302 10.5056 16.5429 9.36057 16.9151 8.05925C17.0299 7.65835 17.0481 7.26221 17.1427 6.86621Z"
      fill="#5FCDFE"
    />
    <path
      d="M9.32262 6.26786L13.2324 6.26921C14.689 6.26901 15.7936 6.15491 17.1292 6.85527L17.1447 6.86633C17.0501 7.26233 17.0319 7.65846 16.9171 8.05936C16.545 9.36068 15.6322 10.5057 14.4839 11.2072C13.1321 12.0325 12.0242 12.0229 10.5217 12.0222L8.41016 12.0207C8.48972 11.7144 8.58828 10.9318 8.64356 10.5788L9.07724 7.78789C9.15274 7.30165 9.22158 6.7413 9.32262 6.26786Z"
      fill="#008CFE"
    />
  </StyledIcon>
)
